import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import NonprofitMortgageHelpPage from "@/pages/tools/NonprofitMortgageHelp";

export const Route = createFileRoute("/tools/nonprofit-mortgage-help")({
  head: () => seoHead("/tools/nonprofit-mortgage-help"),
  component: NonprofitMortgageHelpPage,
});
